import { Dispatch } from 'redux';

import { requestHandler } from '../../api';

export const checkSIIDocumentForUploadingInvoices = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sii/checkDocuments`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const confirmInvoices = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sii/confirmInvoices`,
    data,
    dispatch,
  });
  if (response) return response.data;
};
export const rejectInvoices = async (dispatch: Dispatch, data: any) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sii/rejectInvoices`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const executeInvoiceGeneration = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sii/invoicing/execute`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getDocumentStatus = async (
  dispatch: Dispatch,
  data: {
    invoices: {
      businessIdentifier: string;
      docType: string;
      folio: string;
    }[];
  },
): Promise<
  | {
      businessIdentifier: string;
      docType: string;
      folio: string;
      status: string;
      message: string;
      statusChanged: boolean;
    }[]
  | undefined
> => {
  const response = await requestHandler({
    method: 'post',
    url: `internal/sii/invoicing/document/status`,
    data,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessWithCertificates = async (dispatch: Dispatch) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sii/invoicing/certificates/availables`,
    dispatch,
  });
  if (response) return response.data;
};

export const getBusinessNameByIdentifier = async (
  dispatch: Dispatch,
  data: any,
) => {
  const response = await requestHandler({
    method: 'get',
    url: `internal/sii/getBusinessNameByIdentifier/${data.identifier}`,
    dispatch,
  });
  if (response) return response.data;
};
